/* thepopgift v7 动效层 — GSAP 生产级增强
 * 原则：
 * 1. 渐进增强：GSAP CDN 挂了页面原样可读，内容永不依赖 JS 隐藏
 * 2. 动效克制：一页最多 3 类动效（hero 入场 / 滚动触发 / 轻视差）
 * 3. 移动端降级：<768px 禁用视差，保留轻量入场
 * 4. 尊重 prefers-reduced-motion
 */
(function () {
  'use strict';
  if (!window.gsap) return; // CDN 未加载 → 页面原样（渐进增强）
  var hasST = typeof window.ScrollTrigger !== 'undefined';
  if (hasST) gsap.registerPlugin(ScrollTrigger);

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var isMobile = window.innerWidth < 768;
  var runOnce = 'v7motion';

  function initMotion() {
    // ① Hero 入场（首屏，克制：24px 位移 + 0.6s，交错 0.1s）
    var hero = document.querySelector('.v7-hero-copy');
    if (hero && !hero.dataset[runOnce]) {
      hero.dataset[runOnce] = '1';
      gsap.from(hero.children, {
        y: 24, opacity: 0, duration: 0.6, stagger: 0.1, ease: 'power3.out'
      });
    }

    // ScrollTrigger 未加载 → 跳过全部滚动动画，元素保持可见（渐进增强）
    if (!hasST) return;

    // ② 产品卡 stagger（滚动触发，波浪入场）
    var cardsWrap = document.querySelector('.v7-cards');
    var cards = document.querySelectorAll('.v7-card');
    if (cards.length && cardsWrap && !cardsWrap.dataset[runOnce]) {
      cardsWrap.dataset[runOnce] = '1';
      gsap.from(cards, {
        scrollTrigger: { trigger: cardsWrap, start: 'top 80%' },
        y: 40, opacity: 0, duration: 0.6, stagger: 0.08, ease: 'power3.out'
      });
    }

    // ③ 关键区滚动渐显（trust / products 标题 / reviews / gift / PDP 增强）
    var fadeSections = ['.v7-trust', '.v7-products', '.v7-reviews', '.v7-gift',
                        '.v7-pdp-extra', '.v7-pdp-below > section'];
    fadeSections.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && !el.dataset[runOnce]) {
        el.dataset[runOnce] = '1';
        gsap.from(el, {
          scrollTrigger: { trigger: el, start: 'top 85%' },
          y: 30, opacity: 0, duration: 0.7, ease: 'power3.out'
        });
      }
    });

    // ④ 轻视差（桌面 only，hero 主图随滚动微移 10%）
    if (!isMobile) {
      var media = document.querySelector('.v7-hero-media');
      if (media && !media.dataset[runOnce]) {
        media.dataset[runOnce] = '1';
        gsap.to(media, {
          yPercent: 10, ease: 'none',
          scrollTrigger: { trigger: '.v7-hero', start: 'top top', end: 'bottom top', scrub: true }
        });
      }
    }

    ScrollTrigger.refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMotion);
  } else {
    initMotion();
  }

  // 主题 JS 会动态注入 DOM（header/footer），注入后刷新滚动位置
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () { initMotion(); if (hasST) ScrollTrigger.refresh(); }, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
